import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APP_ICONS } from "../../../assets";
import AppLoader from "../../../components/AppLoader";
import PaperContainer from "../../../components/Containers/PaperContainer";
import GlobalButton from "../../../components/CustomButton";
import GlobalTable from "../../../components/Tables/GlobalTable";
import TextInput from "../../../components/TextInputs";
import useDebounce from "../../../hooks/useDebounce";
import { setSearchKeys } from "../../../lib/slices/searchKeysSlice";
import {
  createNotification,
  getAllNotification,
} from "../../../services/notificationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import PushNotificationDialog from "./PushNotificationDialog";
import { useTranslation } from "react-i18next";

const headerData = ["createdAt", "userType", "title", "body", "actions"];

const tableRows = ["created_date", "userType", "title", "body", "resend_btn"];

function AllNotification() {
  const dispatch = useDispatch();
  const openDialog = useRef(null);
  const { t } = useTranslation(["notification"]);
  const [isLoading, setIsLoading] = useState(false);
  const [allNotification, setAllNotification] = useState([]);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const debouncedSearchTerm = useDebounce(searchKeys.notificationTitle, 1000);

  useEffect(() => {
    fetchAllNotifications(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const fetchAllNotifications = async (title) => {
    try {
      setIsLoading(true);
      const response = await getAllNotification(title);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllNotification(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendNotification = async (row) => {
    try {
      let payload = {
        title: row.title,
        body: row.body,
        userType: row.userType,
        isResend: true,
      };
      setIsLoading(true);
      const response = await createNotification(payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", t("notificationResendSuccess"));
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    dispatch(
      setSearchKeys({
        ...searchKeys,
        notificationTitle: e.target.value,
      })
    );
  };

  const renderHeaderAction = () => {
    return (
      <Stack
        flexGrow={{ xs: 1, sm: 0 }}
        direction={{ md: "row" }}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"addNew"}
          handleClickBtn={() =>
            openDialog.current.openDialog({ getData: fetchAllNotifications })
          }
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            width: "auto",
            height: 40,
          }}
        />
      </Stack>
    );
  };

  const renderSearchAction = () => {
    return (
      <Stack p={2} direction={{ md: "row" }} bgcolor={"primary.light"}>
        <TextInput
          styleProps={{ width: { xs: "100%", md: "35%", xl: "30%" } }}
          InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} />}
          InputEndIcon={
            searchKeys.notificationTitle && (
              <CancelOutlinedIcon
                fontSize="small"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(
                    setSearchKeys({
                      ...searchKeys,
                      notificationTitle: "",
                    })
                  );
                }}
              />
            )
          }
          placeholder={t("searchByName", { ns: "common" })}
          value={searchKeys.notificationTitle}
          onChange={(e) => {
            dispatch(
              setSearchKeys({
                ...searchKeys,
                notificationTitle: e.target.value,
              })
            );
          }}
        />
      </Stack>
    );
  };
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <PaperContainer
        title={t("allNotifications")}
        subtitle={t("sendNotificationsInfo")}
        headerActions={renderHeaderAction()}
        searchActions={renderSearchAction()}
      // showSerach={true}
      // headProps={renderRightPart()}
      // placeholder={"Search title"}
      // searchValue={searchKeys?.notificationTitle}
      // onChange={handleSearchChange}
      >
        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allNotification}
          handleResend={handleResendNotification}
        />
        {allNotification?.length === 0 && isLoading === false && (
          <Typography variant="h5" fontWeight={600} textAlign={"center"}>
            {t("noDataFound", { ns: "common" })}!
          </Typography>
        )}
      </PaperContainer>
      <PushNotificationDialog ref={openDialog} />
    </>
  );
}

export default AllNotification;
